import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, NavLink } from 'react-router-dom'

import './styles/PartnerProduct.scss'

import { inputMaskMoney } from 'util/masks'
import { ApplicationState } from 'AppReducer'
import { getPartnerProduct, updatePartnerProduct, getPartnerProductList } from './redux/actions/product'

import SectionForm from './components/SectionForm'
import ProductSession from './components/ProductSection'

const PartnerProductConfig: React.FC = () => {
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    order: 0,
    basePrice: 0,
    basePriceFormatted: 'R$ 0,00',
    lowestPrice: 0,
    lowestPriceFormatted: 'R$ 0,00',
    cashback: 0
  })

  const { partnerId, id } = useParams<{ partnerId: string, id: string }>()

  const { product } = useSelector((state: ApplicationState) => state.partnerProductReducer)

  function handleSetIsActive (): void {
    if (partnerId && id) {
      const isActive = !product?.isActive
      updatePartnerProduct(partnerId, id, { isActive })(dispatch)
    }
  }

  function handleUpdate (): void {
    if (partnerId && id) {
      updatePartnerProduct(partnerId, id, form)(dispatch)
    }
  }

  useEffect(() => {
    if (product) {
      const [basePriceFormatted, basePrice] = inputMaskMoney(product.basePrice || 0, 'R$')
      const [lowestPriceFormatted, lowestPrice] = inputMaskMoney(product.lowestPrice || 0, 'R$')
      setForm({
        order: product.order,
        basePrice,
        basePriceFormatted,
        lowestPrice,
        lowestPriceFormatted,
        cashback: product.cashback
      })
    }
  }, [product])

  useEffect(() => {
    if (partnerId && id) {
      getPartnerProduct(partnerId, id)(dispatch)
      getPartnerProductList(partnerId)(dispatch)
    }
  }, [partnerId, id, dispatch])

  if (!product) return null

  return (
    <div className="row">
      <h2><i className="fas fa-cogs" /> Configuração de Produto</h2>

      <div className="row panel margin-top-16">
        <div className="row" style={{ width: 300 }}>
          <img className="product-image" src={product.product.pictureTiny} alt="burguer"/>
          <div className="grow padding-left-16">
            <h3 className="bold">{ product.product.name }</h3>
            <p>{ product.product.description }</p>
          </div>
        </div>

        <div className="grow">
          <div className="row align-end">
            <div className="form-control justify-start" style={{ width: 100 }}>
              <label>Ativo?</label>
              <select
                value={product.isActive ? 1 : 0}
                onChange={handleSetIsActive}
              >
                <option value={1}>Sim</option>
                <option value={0}>Não</option>
              </select>
            </div>

            <div className="grow row">
              <label>Ordenação</label>
              <input
                type="number"
                value={form.order}
                onChange={(e): void => setForm({ ...form, order: parseInt(e.target.value) })}
                onBlur={handleUpdate}
              />
            </div>

            <div className="grow row padding-left-16">
              <label>A partir de</label>
              <input
                type="text"
                value={form.lowestPriceFormatted}
                onChange={(e): void => {
                  const [lowestPriceFormatted, lowestPrice] = inputMaskMoney(e.target.value, 'R$')
                  setForm({ ...form, lowestPrice, lowestPriceFormatted })
                }}
                onBlur={handleUpdate}
              />
            </div>

            <div className="grow row padding-left-16">
              <label>Preço Base</label>
              <input
                type="text"
                value={form.basePriceFormatted}
                onChange={(e): void => {
                  const [basePriceFormatted, basePrice] = inputMaskMoney(e.target.value, 'R$')
                  setForm({ ...form, basePrice, basePriceFormatted })
                }}
                onBlur={handleUpdate}
              />
            </div>

            <div className="grow row padding-lr-16">
              <label>Cashback %</label>
              <input
                type="number"
                value={form.cashback}
                onChange={(e): void => setForm({ ...form, cashback: parseInt(e.target.value) })}
                onBlur={handleUpdate}
              />
            </div>

            <NavLink className="button primary" to={`/panel/partner/${partnerId}/product/${id}`}>
              <i className="fas fa-edit" />
            </NavLink>
          </div>
        </div>
      </div>

      <h2 className="margin-top-32">Sessões de Escolha</h2>
      <p>Crie sessões e etapas para composição do preço do produto</p>

      <div className="row panel justify-end align-end margin-top-16">
        <SectionForm />

        <div className="row margin-top-16"/>

        {
          product.sections.length === 0 &&
          <div className="row empty margin-top-8">Nenhuma sessão cadastrada</div>
        }
        {
          product.sections.map((section, i) => (
            <div className="row margin-bottom-16" key={i}><ProductSession section={section} /></div>
          ))
        }
      </div>
    </div>
  )
}

export default PartnerProductConfig
